import AWS from 'aws-sdk';
import {login as loginFB} from './providers/fb.js';
import {login as loginGoogle} from './providers/google.js';
import {linkedinCallback} from './providers/linkedin.js';
import {login as loginCognito} from './providers/cognito.js';
import api from './api.js';
import config from '../config'
import {store} from '../store'

const USER_INFO = 'ba_user_info';

export async function login(provider, email = '', password = '') {
	let info;

	if(provider === 'facebook') {
		info = await loginFB();
	} else if(provider === 'google') {
		info = await loginGoogle();
	} else if(provider === 'linkedin'){
		info = await linkedinCallback(email, password);
	} else if(provider === 'cognito'){
		try {
			info = await loginCognito(email, password);
		} catch(err) {
			throw err;
		}
	} else {
		return;
	}

	if(info) {
		if(provider === 'linkedin') {
			await getLinkedInAwsCredentials(info.provider, info.token, info.identityId);
		} else {
			await getAwsCredentials(info.provider, info.token);
		}

		const user = await api({endpoint: config.services.companies, path: '/setupUser', method: 'POST', body: {token: info.accessToken}});

		store.commit('setFullname', user.name);
		store.commit('setPhoto', user.photo);
		store.commit('setCompanyId', user.companyId);
		store.commit('setCompanyName', user.companyName);
		store.commit('setCompanyActive', user.companyActive);
		store.commit('setDemoMode', user.demoMode);
		store.commit('setLoginInfo', info);
		store.commit('setEmail', user.email);
		store.commit('setProPortalsPerProperty', user.pro && user.pro.portalsPerProperty ? user.pro.portalsPerProperty : false);
		store.commit('setSubscriptions', user.subscriptions);

		if(user.admin) {
			store.commit('setAdmin', user.admin);
			store.commit('setAdminCompanyId', user.adminCompanyId);
			window.location = '/admin';
			return;
		}

		// proptech 2018
		if(user.companyId == '2a1af440-3c06-11e8-a936-2d4d63b504af') {
			window.location = '/company-setup';
			return;
		}

		if(user.companyActive) {
			const properties = await api({endpoint: config.services.properties, path: '/', method: 'GET'});
			if(properties.length == 0) {
				window.location = '/start';
			} else {
				window.location = '/';
			}
		} else {
			window.location = '/company-setup'
		}
	}

}

export async function isLoggedIn() {
	// check aws credentials
	if(AWS.config.credentials && Date.now() < AWS.config.credentials.expireTime - 60000) {
		return true;
	}

	// check user token
	const loginInfo = store.getters.loginInfo;
	const today = new Date();

	if(loginInfo == null || loginInfo.expiration < today.getTime()) {
		return false;
	}

	// refresh aws credentials
	try {
		await getAwsCredentials(loginInfo.provider, loginInfo.token);
	} catch(err) {
		console.log('AWS Auth Error:', err);
		return false;
	}

	$crisp.push(["set", "user:email", store.getters.email]);

	return true;
}

export function logout() {
	if (AWS.config.credentials) {
		AWS.config.credentials.clearCachedId();
		AWS.config.credentials = new AWS.CognitoIdentityCredentials({});
	}

	store.commit('clearAll');

	window.location = '/login';
}

export async function requireAuth(to, from, next) {
	let loggedin = await isLoggedIn();
	if (loggedin) {
		if(!store.state.propertyLists) {
			// get properties lists
			const propertyLists = await api({endpoint: config.services.properties, path: '/lists', method: 'GET'});
			store.commit('setPropertyLists', propertyLists);
		}

		if(!store.getters.companyActive && to.path !== '/company-setup') {
			next('/company-setup');
		} else {
			next();
		}
	} else {
		logout();
	}
}

export async function requireAdmin(to, from, next) {
	let loggedin = await isLoggedIn();

	if(!loggedin) {
		logout();
		return;
	}

	if(store.getters.admin && store.getters.admin === true) {
		next();
	} else {
		next('/');
	}
}

let getAwsCredentials = async function(provider, token) {
	AWS.config.update({ region: config.aws.region });

	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: config.aws.identityPoolId,
		Logins: {
			[provider]: token
		}
	});

	return AWS.config.credentials.getPromise();
}

let getLinkedInAwsCredentials = async function(provider, token, identityId) {
	AWS.config.update({ region: config.aws.region });

	const params = {
		IdentityPoolId: config.aws.identityPoolId,
		RoleSessionName: "web"
	};
	AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);

	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: config.aws.identityPoolId,
		IdentityId: identityId,
		Logins: {
			[provider]: token
		}
	});

	return AWS.config.credentials.getPromise();
}



// WEBPACK FOOTER //
// ./src/libs/auth.js